<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import ButtonRow from "../../components/ButtonRow.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import MemberImage from "../../components/MemberImage.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import { t } from "../../helpers/translation";
</script>

<LightTheme />

<Hero headline={$t("page.team.hero.headline")} small yellow />

<Container />

<Container>
    <Headline center>
        {@html $t("page.team.headline")}
    </Headline>
    <Subline center>
        {@html $t("page.team.subline.1")}
    </Subline>
</Container>

<center>
    <strong>
        {@html $t("page.team.subline.2")}
    </strong>
</center>

<Container>
    <div class="member-images">
        <MemberImage
            name={$t("page.team.member.1.name")}
            work={$t("page.team.member.1.position")}
            bgimg={$t("page.team.member.1.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.2.name")}
            work={$t("page.team.member.2.position")}
            bgimg={$t("page.team.member.2.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.3.name")}
            work={$t("page.team.member.3.position")}
            bgimg={$t("page.team.member.3.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.4.name")}
            work={$t("page.team.member.4.position")}
            bgimg={$t("page.team.member.4.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.5.name")}
            work={$t("page.team.member.5.position")}
            bgimg={$t("page.team.member.5.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.6.name")}
            work={$t("page.team.member.6.position")}
            bgimg={$t("page.team.member.6.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.7.name")}
            work={$t("page.team.member.7.position")}
            bgimg={$t("page.team.member.7.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.8.name")}
            work={$t("page.team.member.8.position")}
            bgimg={$t("page.team.member.8.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.9.name")}
            work={$t("page.team.member.9.position")}
            bgimg={$t("page.team.member.9.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.10.name")}
            work={$t("page.team.member.10.position")}
            bgimg={$t("page.team.member.10.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.11.name")}
            work={$t("page.team.member.11.position")}
            bgimg={$t("page.team.member.11.bgimg")}
        />
        <MemberImage
            name={$t("page.team.member.12.name")}
            work={$t("page.team.member.12.position")}
            bgimg={$t("page.team.member.12.bgimg")}
        />
    </div>
</Container>

<Container>
    <Gap height="4rem" />
    <Image
        src="https://liveicom.azureedge.net/sinus/img/members/azubisnoshadow.png"
    />

    <ButtonRow>
        <Btn yellow arrow href="/ueber-uns/unsere-werte">
            {@html $t("page.team.btn.about")}
        </Btn>
        <Btn arrow href="/aktuelles/news">
            {@html $t("page.team.btn.news")}
        </Btn>
    </ButtonRow>
</Container>

<style lang="scss">
    @import "./src/vars";

    .member-images {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;
        @media (max-width: 800px) {
            grid-template-columns: 1fr;
        }
        :global(.member-image) {
            border-radius: 0.5rem;
            overflow: hidden;
        }
    }
</style>
